/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quick_Add_SuggestionsInputs */

const en_quick_add_suggestions = /** @type {(inputs: Quick_Add_SuggestionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suggestions`)
};

const de_quick_add_suggestions = /** @type {(inputs: Quick_Add_SuggestionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorschläge`)
};

/**
* | output |
* | --- |
* | "Suggestions" |
*
* @param {Quick_Add_SuggestionsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const quick_add_suggestions = /** @type {((inputs?: Quick_Add_SuggestionsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quick_Add_SuggestionsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_quick_add_suggestions(inputs)
	return en_quick_add_suggestions(inputs)
});